module.exports = __webpack_public_path__ + "static/media/image-wakeup-workout@2x.606b6fdb.png";